@if (data?.content?.cards?.length) {
  <div class="container max-width">
    @for (item of data.content.cards; track item) {
      <customer-app-equity-card-item
        [card]="item"
        [small]="$safeNavigationMigration(data?.options?.small)"></customer-app-equity-card-item>
    }
  </div>
}
